import { useEffect, useState } from 'react';
import { User } from '../../models/User';
import { useHttpFetchApi } from '../http/useHttpFetch';

export function useGetPediatricSubject(studyParticipantId?: number | string) {
  const [pediatricSubject, setPediatricSubject] = useState<User | null>();
  const [loadedId, setLoadedId] = useState<number | string | undefined>();
  const [failedId, setFailedId] = useState<number | string | undefined>();
  const { getJson } = useHttpFetchApi();

  useEffect(() => {
    if (studyParticipantId == null || studyParticipantId === '') {
      setPediatricSubject(null);
      setLoadedId(undefined);
      setFailedId(undefined);
      return;
    }
    let stale = false;
    const fail = () => {
      if (stale) return;
      setPediatricSubject(undefined);
      setFailedId(studyParticipantId);
      setLoadedId(studyParticipantId);
    };
    getJson<{ user: User | null }>(
      `study-participants/${studyParticipantId}/pediatric-subject`
    )
      .then(body => {
        if (stale) return;
        // A failed response resolves undefined. user: null is a successful adult result.
        if (!body || !('user' in body)) {
          fail();
          return;
        }
        setPediatricSubject(body.user);
        setFailedId(undefined);
        setLoadedId(studyParticipantId);
      })
      .catch(fail);
    return () => {
      stale = true;
    };
  }, [getJson, studyParticipantId]);

  const hasParticipantId =
    studyParticipantId != null && studyParticipantId !== '';

  return {
    pediatricSubject: pediatricSubject || undefined,
    pediatricSubjectError: hasParticipantId && failedId === studyParticipantId,
    loadingPediatricSubject: hasParticipantId && loadedId !== studyParticipantId
  };
}
